export function getQuickFilterTextForStringArrayColumn({ value }) {
  if (Array.isArray(value)) {
    return value.join(',');
  }
  return String(value || '');
}

export const getQuickFilterTextWithSkippingAddedRow = rowParams => {
  if (rowParams.data.meta.isAdded) {
    return rowParams.node.beans.gridApi.filterManager.quickFilter;
  }
  return rowParams.value;
};
